<div class="page-title-area item-bg2">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Services</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Services</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="services-section pt-100 pb-70">
  <app-our-data-service></app-our-data-service>
</section>

<section class="software-section pb-100">
<app-our-working-process></app-our-working-process>
</section>

<section class="subscribe-section pb-100">
<app-feedback></app-feedback>
</section>
